function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import _extends from "@babel/runtime/helpers/esm/extends";
var MAX_CONCURRENT_REQUESTS = Infinity;
export var runIfServerMode = function(modeProp, fn) {
    return function() {
        if (modeProp === 'server') {
            fn();
        }
    };
};
export var RequestStatus = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus[RequestStatus["QUEUED"] = 0] = "QUEUED";
    RequestStatus[RequestStatus["PENDING"] = 1] = "PENDING";
    RequestStatus[RequestStatus["SETTLED"] = 2] = "SETTLED";
    RequestStatus[RequestStatus["UNKNOWN"] = 3] = "UNKNOWN";
    return RequestStatus;
}({});
/**
 * Fetches row children from the server with option to limit the number of concurrent requests
 * Determines the status of a request based on the enum `RequestStatus`
 * Uses `GridRowId` to uniquely identify a request
 */ export var NestedDataManager = function NestedDataManager(privateApiRef) {
    "use strict";
    var _this = this;
    var maxConcurrentRequests = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : MAX_CONCURRENT_REQUESTS;
    _class_call_check(this, NestedDataManager);
    var _this1 = this;
    this.pendingRequests = new Set();
    this.queuedRequests = new Set();
    this.settledRequests = new Set();
    this.api = void 0;
    this.maxConcurrentRequests = void 0;
    this.processQueue = /*#__PURE__*/ _async_to_generator(function() {
        var loopLength, fetchQueue, i, id;
        return _ts_generator(this, function(_state) {
            if (_this1.queuedRequests.size === 0 || _this1.pendingRequests.size >= _this1.maxConcurrentRequests) {
                return [
                    2
                ];
            }
            loopLength = Math.min(_this1.maxConcurrentRequests - _this1.pendingRequests.size, _this1.queuedRequests.size);
            if (loopLength === 0) {
                return [
                    2
                ];
            }
            fetchQueue = Array.from(_this1.queuedRequests);
            for(i = 0; i < loopLength; i += 1){
                id = fetchQueue[i];
                _this1.queuedRequests.delete(id);
                _this1.pendingRequests.add(id);
                _this1.api.fetchRowChildren(id);
            }
            return [
                2
            ];
        });
    });
    this.queue = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(ids) {
            var loadingIds;
            return _ts_generator(this, function(_state) {
                loadingIds = {};
                ids.forEach(function(id) {
                    _this1.queuedRequests.add(id);
                    loadingIds[id] = true;
                });
                _this1.api.setState(function(state) {
                    return _extends({}, state, {
                        dataSource: _extends({}, state.dataSource, {
                            loading: _extends({}, state.dataSource.loading, loadingIds)
                        })
                    });
                });
                _this1.processQueue();
                return [
                    2
                ];
            });
        });
        return function(ids) {
            return _ref.apply(this, arguments);
        };
    }();
    this.setRequestSettled = function(id) {
        _this.pendingRequests.delete(id);
        _this.settledRequests.add(id);
        _this.processQueue();
    };
    this.clear = function() {
        _this.queuedRequests.clear();
        Array.from(_this.pendingRequests).forEach(function(id) {
            return _this.clearPendingRequest(id);
        });
    };
    this.clearPendingRequest = function(id) {
        _this.api.unstable_dataSource.setChildrenLoading(id, false);
        _this.pendingRequests.delete(id);
        _this.processQueue();
    };
    this.getRequestStatus = function(id) {
        if (_this.pendingRequests.has(id)) {
            return RequestStatus.PENDING;
        }
        if (_this.queuedRequests.has(id)) {
            return RequestStatus.QUEUED;
        }
        if (_this.settledRequests.has(id)) {
            return RequestStatus.SETTLED;
        }
        return RequestStatus.UNKNOWN;
    };
    this.getActiveRequestsCount = function() {
        return _this.pendingRequests.size + _this.queuedRequests.size;
    };
    this.api = privateApiRef.current;
    this.maxConcurrentRequests = maxConcurrentRequests;
};
